module.exports = __webpack_public_path__ + "static/TableCheck-b0f3f03c5a84f7a7d59cc8aa18aaebd0.svg";